import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { RespectOrchestratorState } from "@nju/feature-portal-orchestrator";
import { GoToNextNumber } from "@nju/feature-portal-order";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../components/ClientSideRenderer";

export default function GoToNextNumberPage() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent>
        <ClientSideOnly>
          <RespectOrchestratorState
            allowMissingState={true}
            mode="mobile"
            state={["ITEM_SELECTION", "LEGACY_MIGRATION_ERROR"]}
          >
            <GoToNextNumber />
          </RespectOrchestratorState>
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
